import { createSlice } from '@reduxjs/toolkit'
import ApiClient from "../ApiClient"
export const employeeSlice = createSlice({
    name:"employees",
    initialState:{
        employees:[],
    },
    reducers:{
        setEmployees: (state,action) =>{
            state.employees = action.payload;
        },      
    }
});

export const fetchAllEmployees = () => async dispatch => {
    try{
        const {data} = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/admin/getEmpDetails`)
                const uniqueEmployees = [
            ...new Map(data.map(emp => [emp.EMP_ID, emp])).values()
        ];
        dispatch(employeeSlice.actions.setEmployees(uniqueEmployees));
    }
    catch(error){
        dispatch(employeeSlice.actions.setEmployees([]))
    }
}

export const {setEmployees} = employeeSlice.actions;
export const selectEmployees = (state) => state.employees.employees;
export default employeeSlice.reducer;